<template lang="pug">
box
  page-title(slot="page-title", title="Nota recebida")
  load-manager.scrollable(slot="content", :loading="loading", :errors="errors")
    .container.grid-lg(v-if="nota")
      .columns
        .column.col-6.col-sm-12.my-2
          text-output(label="Número", :text="nota.numero")
          text-output(
            label="Código de verificação",
            :text="nota.codigo_verificacao"
          )
        .column.col-6.col-sm-12.my-2
          text-output(label="Data emissão", :text="nota.created_at | date")
          text-output(label="Situação", :text="nota.situacao.descricao")
      .divider.text-center(data-content="Prestador")
      .columns
        .column.col-auto.my-2
          img.img-responsive.image.s-rounded.img-prestador(
            :src="logoPrestador"
          )
        .column.col-8.col-sm-12.my-2
          text-output(
            :label="'pessoa.razao_social' | tModel",
            :text="nota.prestador.razao_social"
          )
          text-output(
            :label="'pessoa.endereco' | tModel",
            :text="nota.prestador.endereco_formatado"
          )
        .column.col-4.col-sm-6.my-2
          text-output(
            :label="'pessoa.cpf_cnpj' | tModel",
            :text="nota.prestador.cpf_cnpj | cpfCnpj"
          )
        .column.col-4.col-sm-6.my-2
          text-output(
            :label="'pessoa.fone' | tModel",
            :text="nota.prestador.fone | phone"
          )
        .column.col-4.col-sm-12.my-2
          text-output(
            :label="'pessoa.email' | tModel",
            :text="nota.prestador.email"
          )
      .divider.text-center(data-content="Discriminação")
      .text.pre-wrap {{ nota.discriminacao }}
      .divider.text-center(data-content="Lista serviço")
      .text {{ nota.lista_servico.codigo_servico | mask("##.##") }} - {{ nota.lista_servico.descricao }}
      .divider.text-center(data-content="Valores")
      .columns
        .column.col-6.my-2.text-bold.text-success
          .text Valor serviços
        .column.col-6.my-2.text-right.text-bold.text-success {{ nota.valor_servicos | currency("R$") }}
        .column.col-12.divider.my-2
        .column.col-3.col-sm-6.my-2
          text-output(
            label="Valor deduções",
            :text="nota.valor_deducoes | currency('R$')"
          )
          text-output(
            label="Valor ISS",
            :text="nota.valor_iss | currency('R$')"
          )
          text-output(label="Valor IR", :text="nota.valor_ir | currency('R$')")
          text-output(
            label="Valor líquido NFS-e",
            :text="nota.valor_liquido_nfse | currency('R$')"
          )
        .column.col-3.col-sm-6.my-2
          text-output(
            label="Desconto incondicionado",
            :text="nota.desconto_incondicionado | currency('R$')"
          )
          text-output(
            label="Valor PIS",
            :text="nota.valor_pis | currency('R$')"
          )
          text-output(
            label="Valor CSLL",
            :text="nota.valor_csll | currency('R$')"
          )
          text-output(label="Competência", :text="nota.competencia")
        .column.col-3.col-sm-6.my-2
          text-output(
            label="Base cálculo",
            :text="nota.base_calculo | currency('R$')"
          )
          text-output(
            label="Valor COFINS",
            :text="nota.valor_cofins | currency('R$')"
          )
          text-output(
            label="Outras retenções",
            :text="nota.outras_retencoes | currency('R$')"
          )
          text-output(
            label="Responsável recolhimento",
            :text="nota.tipo_recolhimento | capitalize"
          )
        .column.col-3.col-sm-6.my-2
          text-output(
            label="Alíquota",
            :text="nota.aliquota | currency('', '%')"
          )
          text-output(
            label="Valor INSS",
            :text="nota.valor_inss | currency('R$')"
          )
          text-output(
            label="Desconto condicionado",
            :text="nota.desconto_condicionado | currency('R$')"
          )
          text-output(
            label="Optante pelo Simples",
            :text="nota.simples | boolean"
          )
      .divider.text-center(data-content="Informações da nota")
      .columns
        .column.col-6.col-sm-12.my-2
          text-output(
            label="Regime especial",
            :text="nota.regime_especial ? nota.regime_especial.descricao : ''"
          )
        .column.col-6.col-sm-12.my-2
          text-output(label="Situação", :text="nota.situacao.descricao")
        .column.col-6.col-sm-12.my-2
          text-output(
            label="Exigibilidade ISS",
            :text="nota.exigibilidade_iss"
          )
        .column.col-6.col-sm-12.my-2
          text-output(
            label="Município incidência",
            :text="nota.municipio_incidencia | municipio"
          )
      .columns.my-2
        .column.col-6.col-sm-12
          a.btn.btn-link.text-success(:href="nota.url", target="_blank")
            i.fa.fa-print
            span &nbsp;Visualizar impressão
        #recusar.column.col-6.col-sm-12(v-if="nota.permite_recusar")
          router-link.btn.btn-link.text-error(
            :to="{ name: 'app.notaRecebida.recusar' }"
          )
            i.fa.fa-remove
            span &nbsp;Recusar nota
    router-view
</template>

<script>
import showMixin, { defaultStoreImports } from "@/mixins/show";
import Nfe from "@/models/Nfe";

export default {
  vuex: { notasRecebidas: defaultStoreImports },
  mixins: [showMixin],
  computed: {
    nota() {
      return this.current ? new Nfe(this.current) : null;
    },
    logoPrestador() {
      return this.nota.prestador.url_thumb || require("@/assets/prestador.png");
    },
  },
};
</script>

<style lang="stylus" scoped>
.img-prestador {
  max-width: 100px;
  margin: 0 auto;
}
</style>